import { useNavigate} from 'react-router-dom';
import { logout } from './Logout';
import { NavLink } from 'react-router-dom';
import { useState,useEffect ,useContext, useRef, useCallback } from 'react';
import $ from 'jquery';
import axios from 'axios';
import Select from 'react-select';
import Swal from 'sweetalert2';
import apiurl from './Api';
import RefreshContext from './Components/RefreshContext';

function Header({mobile,banda,ttypess}){
    const { refreshKey, triggerRefresh } = useContext(RefreshContext);
  
    const navigate = useNavigate();
    const [apps,setApp]=useState([]);
    const [userPost,setUserPost]= useState("");
    const [Session,setSession]= useState("");
    const [show,setCamp]= useState(0);
    const [notification,seNot] = useState([]);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [openMenu, setOpenMenu] = useState(null);
    const [showLeft, setShowLeft] = useState(false);
    const [showRight, setShowRight] = useState(true);
    const [menuWidth, setMenuWidth] = useState("100%");
    const [roles, setRoles] = useState([]);
    const [sessionUsername, setSessionUsername] = useState("");
    const [showSwitchModal, setShowSwitchModal] = useState(false);
    const [switchingRole, setSwitchingRole] = useState(false);
    const profileRef = useRef(null);
    const notifRef = useRef(null);
    const navScrollRef = useRef(null);
    const mobileMenuButtonRef = useRef(null);
    const mobileMenuDropdownRef = useRef(null);

    const toggleMenu = (menuName) => {
        setOpenMenu(openMenu === menuName ? null : menuName);
    };

    const fetchData2 = async () => {
      $("#showLoader").removeClass('d-none').addClass('d-flex');
      const response = await axios.get(apiurl+'access.php?subdomain=react'); // Replace with your API endpoint
      setApp(response.data.access);
      setUserPost((response.data.post || "").toString().toLowerCase().replace(/ /g,'_'));
      setSession(response.data.types);
      setCamp(response.data.campaignmenu);
      seNot(response.data.notification || []);
      try {
        const sessionResponse = await axios.post(apiurl + "session.php");
        setRoles(Array.isArray(sessionResponse.data?.roles) ? sessionResponse.data.roles : []);
        setSessionUsername((sessionResponse.data?.session_username || "").toString());
      } catch (error) {
        setRoles([]);
        setSessionUsername("");
      }
      $("#showLoader").removeClass('d-flex').addClass('d-none');
    
    };

   const yourApiCallFunction = () => {
      axios.get(apiurl+'access.php?type=noti'); // Replace with your API endpoint
    };
 
  const handleLogout = (e) => {
    e.preventDefault();
     logout(navigate);
  };

  const handleSwitchProfile = async (selectedRole) => {
    if (!selectedRole?.value || switchingRole) return;
    setSwitchingRole(true);
    try {
      await axios.post(
        apiurl + "session.php",
        new URLSearchParams({ switch_post: selectedRole.value })
      );
      setOpenMenu(null);
      setIsMenuOpen(false);
      setShowSwitchModal(false);
      triggerRefresh();
      navigate("/admin", { replace: true });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Switch Profile Failed",
        text: error?.response?.data?.messages || error.message || "Unable to switch profile",
      });
    } finally {
      setSwitchingRole(false);
    }
  };

  useEffect(() => {
      fetchData2();
  }, [refreshKey]);

  useEffect(() => {
    if ((userPost === "executive" || userPost === "executive_manager") && apps.length > 0) {
      const path = window.location.pathname.replace(/\/$/, "");
      if (path === "/admin") {
        const automationApp = apps.find((a) => a.url === "automation-activity");
        const target = automationApp && automationApp.id
          ? `/admin/automation-activity/${automationApp.id}`
          : "/admin/automation-activity";
        navigate(target, { replace: true });
      }
    }
  }, [userPost, apps, navigate]);

  const updateMenuScrollState = useCallback(() => {
    const container = navScrollRef.current;
    if (!container) return;

    const maxScroll = container.scrollWidth - container.clientWidth;
    const hasOverflow = maxScroll > 2;

    setShowLeft(hasOverflow && container.scrollLeft > 0);
    setShowRight(hasOverflow && container.scrollLeft < maxScroll - 2);
  }, []);

  useEffect(() => {
  const container = navScrollRef.current;
  if (!container) return;

  const checkScroll = () => updateMenuScrollState();
  const resizeObserver = new ResizeObserver(checkScroll);
  const frame = requestAnimationFrame(checkScroll);

  container.addEventListener("scroll", checkScroll);
  window.addEventListener("resize", checkScroll);
  resizeObserver.observe(container);
  if (container.parentElement) resizeObserver.observe(container.parentElement);

  return () => {
    cancelAnimationFrame(frame);
    container.removeEventListener("scroll", checkScroll);
    window.removeEventListener("resize", checkScroll);
    resizeObserver.disconnect();
  };
}, [updateMenuScrollState]);

useEffect(() => {

  const calculateMenuWidth = () => {
    setMenuWidth("none");
  };

  calculateMenuWidth();

  window.addEventListener("resize", calculateMenuWidth);

  return () => window.removeEventListener("resize", calculateMenuWidth);

}, [apps]);

useEffect(() => {
  const container = document.getElementById("mobileNav");
  if (!container) return;

  const frame = requestAnimationFrame(() => {
    updateMenuScrollState();
  });

  return () => cancelAnimationFrame(frame);
}, [apps, menuWidth, Session, ttypess, updateMenuScrollState]);

useEffect(() => {
  const handleClickOutside = (e) => {
    const isProfileClick = profileRef.current && profileRef.current.contains(e.target);
    const isNotifClick = notifRef.current && notifRef.current.contains(e.target);
    const isMobileClick =
      (mobileMenuButtonRef.current && mobileMenuButtonRef.current.contains(e.target)) ||
      (mobileMenuDropdownRef.current && mobileMenuDropdownRef.current.contains(e.target));

    if (!isProfileClick && openMenu === 'profile') {
      setOpenMenu(null);
    }
    if (!isNotifClick && openMenu === 'notif') {
      setOpenMenu(null);
    }
    if (!isMobileClick && isMenuOpen) {
      setIsMenuOpen(false);
    }
  };

  document.addEventListener("mousedown", handleClickOutside);
  return () => document.removeEventListener("mousedown", handleClickOutside);
}, [openMenu, isMenuOpen]);
  
const scrollMenu = (direction) => {
  const container = document.getElementById("mobileNav");
  if (!container) return;

  const scrollAmount = 250;

  if (direction === "left") {
    container.scrollBy({ left: -scrollAmount, behavior: "smooth" });
  } else {
    container.scrollBy({ left: scrollAmount, behavior: "smooth" });
  }

  window.setTimeout(updateMenuScrollState, 300);
};
      
 return(
<>    

  <aside className="app-sidebar sticky" id="sidebar" style={{top:'0', display:'flex', alignItems:'center'}}>

    <div className="main-sidebar-header">
        <NavLink className="header-logo">
            <img src={"/images/meraqui-logo.png"} alt="logo" className="desktop-dark"/>
        </NavLink>
    </div>
    
    {/*Start::main-sidebar */}
  <div className="main-sidebar" id="sidebar-scroll">
  {/* Start::nav */}
  <nav className="main-menu-container nav nav-pills sub-open align-items-center" id="mobileScreen" style={{marginTop:'0', width:'100%', minHeight:'58px', height:'58px', overflow:'hidden', display:'flex', flexWrap:'nowrap', alignItems:'center', gap:'8px'}}>
   <div className="" id="slide-left" style={{height:'100%',display:'flex', flex:'0 0 auto', alignItems:'center', paddingLeft:'24px'}}>
   
     <button type="button" className="btn header-link shadow-none border-0 d-none" id="mainHeaderProfile2" 
      ref={mobileMenuButtonRef}
      onClick={() => setIsMenuOpen(!isMenuOpen)} style={{ backgroundColor: 'transparent', padding: '0px',alignItems: 'center'}}>
      <i className="ri-menu-line" style={{ color: '#fff',fontSize:'22px' }}></i>
    </button>
    

     <NavLink to="/admin" className="header-logo">
       <img src={"/images/meraqui-logo.png"} alt="logo" className="desktop-dark" style={{height:'35px',width:'100%'}}/>
    </NavLink>

    {showLeft && (
    <button onClick={() => scrollMenu("left")} style={{background:'transparent',border:'none',color:'#fff',fontSize:'22px',cursor:'pointer'}}>
      <i className="ri-arrow-left-s-line"></i>
    </button>
    )}
    </div>
    
    {/* Scrollable menu */}
    <ul className="main-menu align-items-center" id="mobileNav" ref={navScrollRef} style={{
    overflowX: "auto",
    overflowY: "hidden",
    maxWidth: "100%",
    flex: "1 1 0",
    minWidth: 0,
    width: 0,
    height: "100%",
    display: "flex",
    alignItems: "center",
    flexWrap: "nowrap",
    whiteSpace: "nowrap"
  }}>
 
      {!(userPost === "executive" || userPost === "executive_manager") && (
      <li className="slide">
        <NavLink to="/admin" end className={({ isActive }) =>"side-menu__item" + (isActive ? " active" : "")}>
          <i className="bx bx-home side-menu__icon"></i>
          <span className="side-menu__label">Dashboards</span>
        </NavLink>
      </li>
      )}

      {ttypess && ttypess.toUpperCase() === "ADMIN" && (
        <>
       {apps.map((pro, index) => {
          const pp = pro.id ? `/${pro.id}` : '';
          const basePath = `/admin/${pro.url}${pp}`;
          const full = pro.descr === "okay2" ? pro.url : basePath;
            return (
              <li className="slide" key={index}>
                <NavLink
                  to={full}
                  className={({ isActive }) =>
                    "side-menu__item" + (isActive ? " active" : "")
                  }
                  target={pro.descr==="okay2" ? "_blank" : "_self"}
                  rel={pro.descr==="okay2" ? "noopener noreferrer" : ""}>
                  <i className={`${pro.icon} side-menu__icon`}></i>
                  <span className="side-menu__label">{pro.name}</span>
                </NavLink>
              </li>
            );
            })}
        </>
      )}
      
           
    {(Session && (Session.toUpperCase() === "STAFF" || Session.toUpperCase() === "VENDOR")) && (
        <>
      {/* INDEX 0 ALWAYS FIRST */}
        {apps[0] && (() => {
          const pro = apps[0];
          const shouldIncludeId = pro.okay && pro.okay !== 0;
          const basePath = `/admin/${pro.url}/${pro.id}`;
          const fullPath = shouldIncludeId ? `${basePath}${pro.okay}` : basePath;
          const full = pro.descr === "okay" ? pro.url : fullPath;

          return (
            <li className="slide">
              <NavLink
                to={full}
                className={({ isActive }) =>
                  "side-menu__item" + (isActive ? " active" : "")
                }
              >
                <i className={`${pro.icon} side-menu__icon`} />
                <span className="side-menu__label">{pro.name}</span>
              </NavLink>
            </li>
          );
        })()}

        {/* CAMPAIGN AFTER INDEX 0 */}
        {show === 1 && (
          <li className="slide dropdown">
            <a
              href="#"
              className="side-menu__item dropdown-toggle"
              data-bs-toggle="dropdown"
              role="button"
              aria-expanded="false"
            >
              <span className="side-menu__label">Campaign</span>
            </a>

            <ul className="dropdown-menu">
              {[1, 2].map(i => {
                const pro = apps[i];
                if (!pro) return null;

                const shouldIncludeId = pro.okay && pro.okay !== 0;
                const basePath = `/admin/${pro.url}/${pro.id}`;
                const fullPath = shouldIncludeId
                  ? `${basePath}${pro.okay}`
                  : basePath;

                return (
                  <li key={i}>
                    <NavLink
                      to={fullPath}
                      className={({ isActive }) =>
                        "dropdown-item" + (isActive ? " active" : "")
                      }
                    >
                      {pro.name}
                    </NavLink>
                  </li>
                );
              })}
            </ul>
          </li>
        )}

        {/* REST OF ITEMS */}
        {apps.map((pro, index) => {
          if (index === 0) return null;
          if (show === 1 && (index === 1 || index === 2)) return null;

          const shouldIncludeId = pro.okay && pro.okay !== 0;
          const basePath = `/admin/${pro.url}/${pro.id}`;
          const fullPath = shouldIncludeId ? `${basePath}${pro.okay}` : basePath;
          const full = pro.descr === "okay" || pro.descr==='okay2' ? pro.url : fullPath;

          return (
            <li key={index} className="slide">
              <NavLink
                to={full}
                className={({ isActive }) =>
                  "side-menu__item" + (isActive ? " active" : "")
                }
                target={pro.descr==='okay' || pro.descr=='okay2' ? "_blank" : "_self"}
                rel={pro.descr==='okay' || pro.descr=='okay2' ? "noopener noreferrer" : ""}
              >
                <i className={`${pro.icon} side-menu__icon`} />
                <span className="side-menu__label">{pro.name}</span>
              </NavLink>
            </li>
          );
        })}
        </>
    )}
    </ul>
                     
<div className="slide-right" id="slide-right" style={{ display: 'flex', gap: '17px', paddingTop: '0', paddingRight: '28px', backgroundColor: 'transparent', borderColor: 'transparent', flex: '0 0 auto', alignItems: 'center', alignSelf: 'stretch', marginLeft: '0', minWidth: 'fit-content', position: 'relative', zIndex: 2 }}>
   <div style={{position:'relative'}}>
    {showRight && (
<button
  onClick={() => scrollMenu("right")}
  style={{
    background:'transparent',
    border:'none',
    color:'#fff',
    fontSize:'22px',
    cursor:'pointer'
  }}
>
  <i className="ri-arrow-right-s-line"></i>
</button>
)}
   </div>
    {/* --- NOTIFICATION SECTION --- */}
    <div style={{ position: 'relative' }} ref={notifRef}>
        <button 
            type="button"
            className="btn header-link shadow-none border-0" 
            onClick={() =>{ toggleMenu('notif');

              if (openMenu !== 'notif' && notification.length > 0) {
                yourApiCallFunction(); 
            }
            }}
            style={{ position: 'relative', marginTop: '0', padding:'0px', backgroundColor: 'transparent', height: '100%', display: 'flex', alignItems: 'center' }}
        >
            <i className="bx bx-bell header-link-icon" style={{ fontSize: '21px', color: '#fff' }}></i>
            {/* --- BADGE SECTION --- */}
            {notification.length > 0 && (
            <span style={{position:'absolute',top: '-6px',right: '-4px'}} className="badge bg-danger rounded-pill header-icon-badge pulse pulse-secondary" id="notification-icon-badge">
              {notification.length}
            </span>
           )}
            </button>

        <div className={`main-header-dropdown dropdown-menu dropdown-menu-end ${openMenu === 'notif' ? 'show' : ''}`} 
             style={{ display: openMenu === 'notif' ? 'block' : 'none', width: '400px', position: 'fixed', top: '60px', right: '80px', zIndex: 9999 }}>
            <div className="p-3">
                <div className="d-flex align-items-center justify-content-between">
                    <p className="mb-0 fs-17 fw-semibold">Notifications</p>
                    {notification.length > 0 && (
                    <span className="badge bg-secondary-transparent">{notification.length} New</span>
                   )}
                </div>
            </div>
            <div className="dropdown-divider"></div>
            <ul className="list-unstyled mb-0" id="header-notification-scroll" style={{maxHeight: '300px', overflowY: 'auto'}}>
                {notification.length > 0 ? (
                  notification.map((not, index) => (
                    <li className="dropdown-item" key={index} onClick={() => setOpenMenu(null)}>
                        <div className="d-flex align-items-start">
                            <div className="pe-2">
                                <span className={`avatar avatar-md ${not.class} avatar-rounded`}>
                                    <i className={`ti ${not.icon || 'ti-bell'} fs-18`}></i>
                                </span>
                            </div>
                            <div className="flex-grow-1">
                                <p className="mb-0 fw-semibold">
                                    <NavLink to="/admin/notification" dangerouslySetInnerHTML={{ __html: not.title || "New Notification" }} />
                                </p>
                                <span className="text-muted fw-normal fs-12" dangerouslySetInnerHTML={{ __html: not.message }} />
                            </div>
                        </div>
                    </li>
                  ))

                ) : (
                <li className="p-4 text-center" style={{display: 'flex',flexDirection:'column',alignItems: 'center',gap: '13p'}}>
                    <img src={process.env.PUBLIC_URL + "/images/media/no-data.svg"} alt="No Data" style={{ width: '80px', marginBottom: '10px' }} />
                    <p className="text-muted mb-0">No New Notifications</p>
                </li>
            )}
            </ul>
            <div className="p-3 border-top">
                <div className="d-grid">
                    <NavLink to="/admin/notification" className="btn btn-primary" onClick={() => setOpenMenu(null)}>View All</NavLink>
                </div>
            </div>
        </div>
    </div>

    {/* --- PROFILE SECTION --- */}
    <div style={{ position: 'relative' }} ref={profileRef}>
        <button 
            type="button"
            className="btn header-link shadow-none border-0" 
            onClick={() => toggleMenu('profile')}
            style={{ backgroundColor: 'transparent' ,padding:'0px'}}
        >
            <div className="d-flex align-items-center">
                <div className="me-sm-2 me-0">
                    <img src={process.env.PUBLIC_URL + "/admin_assets/images/9.jpg"} alt="img" width="32" height="32" className="rounded-circle" />
                </div>
                <div className="d-sm-block d-none">
                    <p className="fw-semibold mb-0 lh-1" style={{ color: '#fff' }}>{banda.toUpperCase()}</p>
                </div>
            </div>
        </button>

        <ul className={`main-header-dropdown dropdown-menu pt-0 overflow-hidden header-profile-dropdown dropdown-menu-end ${openMenu === 'profile' ? 'show' : ''}`}
            style={{ display: openMenu === 'profile' ? 'block' : 'none', position: 'fixed', top: '60px', right: '15px', zIndex: 9999, minWidth: '200px' }}>
            {roles.length > 1 && (
              <li className="dropdown-item d-flex" style={{ cursor: 'pointer' }} onClick={() => { setShowSwitchModal(true); setOpenMenu(null); }}>
                  <i className="ri-arrow-left-right-line fs-16 me-2"></i>Switch Profile
              </li>
            )}
            <li className="dropdown-item d-flex" style={{ cursor: 'pointer' }} onClick={() => { navigate("/admin/profile"); setOpenMenu(null); }}>
                <i className="ri-profile-fill fs-16 me-2"></i>Profile
            </li>
            <li className="dropdown-item d-flex" style={{ cursor: 'pointer' }} onClick={() => { navigate("/admin/change"); setOpenMenu(null); }}>
                <i className="ri-lock-password-line fs-16 me-2"></i>Change Password
            </li>
            <li className="dropdown-item d-flex" style={{ cursor: 'pointer' }} onClick={(e) => { handleLogout(e); setOpenMenu(null); }}>
                <i className="ti ti-logout fs-16 me-2"></i>Log Out
            </li>
        </ul>
    </div>
</div>

  </nav>
</div>

</aside>

<ul className="main-header-dropdown dropdown-menu pt-0 overflow-hidden header-profile-dropdown dropdown-menu-end" id="drops" aria-labelledby="mainHeaderProfile2" ref={mobileMenuDropdownRef} style={{ minWidth: '200px', position: 'absolute', zIndex: 9999 ,display: isMenuOpen ? 'block' : 'none',}}>
    {/* --- Dynamic Mobile Nav Logic Inside Dropdown --- */}
    {!(userPost === "executive" || userPost === "executive_manager") && (
    <li className="dropdown-item d-flex">
        <NavLink to="/admin" end className="text-dark w-100">
            <i className="bx bx-home me-2"></i> Dashboards
        </NavLink>
    </li>
    )}

    {ttypess && ttypess.toUpperCase() === "ADMIN" && (
        <>
            <li className="dropdown-item d-flex">
                <NavLink to="/admin/app" className="text-dark w-100">
                    <i className="bx bx-medal me-2"></i> Add App
                </NavLink>
            </li>
            <li className="dropdown-item d-flex">
                <NavLink to="/admin/staff" className="text-dark w-100">
                    <i className="bx bx-fingerprint me-2"></i> Add Staff
                </NavLink>
            </li>
        </>
    )}

    {(Session && (Session.toUpperCase() === "STAFF" || Session.toUpperCase() === "VENDOR")) && (
        <>
            {/* INDEX 0 */}
            {apps[0] && (() => {
                const pro = apps[0];
                const shouldIncludeId = pro.okay && pro.okay !== 0;
                const fullPath = shouldIncludeId ? `/admin/${pro.url}/${pro.id}${pro.okay}` : `/admin/${pro.url}/${pro.id}`;
                const full = pro.descr === "okay" ? pro.url : fullPath;
                return (
                    <li className="dropdown-item d-flex">
                        <NavLink to={full} className="text-dark w-100">
                            <i className={`${pro.icon} me-2`} /> {pro.name}
                        </NavLink>
                    </li>
                );
            })()}

            {/* REST OF ITEMS (Skipping 1 and 2 if campaign is showing elsewhere) */}
            {apps.map((pro, index) => {
                if (index === 0) return null;
                
                const shouldIncludeId = pro.okay && pro.okay !== 0;
                const fullPath = shouldIncludeId ? `/admin/${pro.url}/${pro.id}${pro.okay}` : `/admin/${pro.url}/${pro.id}`;
                const full = pro.descr === "okay" ? pro.url : fullPath;

                return (
                    <li key={index} className="dropdown-item d-flex">
                        <NavLink to={full} className="text-dark w-100">
                            <i className={`${pro.icon} me-2`} /> {pro.name}
                        </NavLink>
                    </li>
                );
            })}
        </>
    )}

    <hr className="dropdown-divider" />
    {roles.length > 1 && (
      <li className="dropdown-item d-flex" style={{ cursor: 'pointer' }} onClick={() => { setShowSwitchModal(true); setIsMenuOpen(false); }}>
          <i className="ri-arrow-left-right-line fs-16 me-2"></i>Switch Profile
      </li>
    )}
    <li className="dropdown-item d-flex text-danger" style={{ cursor: 'pointer' }} onClick={handleLogout}>
        <i className="ti ti-logout fs-16 me-2"></i>Log Out
    </li>
</ul>
{showSwitchModal && (
  <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0,0,0,0.5)',
      zIndex: 10000,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
  }}>
      <div style={{ backgroundColor: '#fff', padding: '30px', borderRadius: '10px', width: '90%', maxWidth: '420px' }}>
          <h5 className="mb-3">Switch Profile</h5>
          <p className="text-muted small">Choose the role you want to continue with.</p>
          <Select
              options={roles}
              placeholder="Search & Select Role..."
              value={roles.find((role) => role.value === sessionUsername) || null}
              onChange={handleSwitchProfile}
              isDisabled={switchingRole}
              autoFocus
          />
          <button
              onClick={() => !switchingRole && setShowSwitchModal(false)}
              className="btn btn-sm btn-light mt-4 w-100"
              disabled={switchingRole}
          >
              {switchingRole ? "Switching..." : "Cancel"}
          </button>
      </div>
  </div>
)}
<div id="showLoader" className="d-none justify-content-center align-items-center" style={{inset:'0',position: 'fixed',background: '#00000038', width: '100%', height: '100%', zIndex: 9999999,alignItems: 'center' }}> 
  <div className="spinner-border" role="status"> <span className="visually-hidden">Loading...</span> </div> 
</div>
</>
);
}
export default Header;
